import * as React from 'react'
import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { NavLink } from 'react-router-dom'
import ButtonBase from '@material-ui/core/ButtonBase'
import { IconSeekers, IconButtonSeeker } from 'ui-seeker/core'
import { getAppUserData } from '../../../@utils'
import { ADMIN_MENU } from '../../../@common/constants'

const listData = Object.values(ADMIN_MENU)

const ICON_STYLE = { width: 20, textAlign: 'center', flexShrink: 0 }

export default function AdminSectionPanel({ isOpen, onClose }) {
    const [expanded, setExpanded] = useState(null)
    const [portalTarget, setPortalTarget] = useState(null)
    const appUserData = getAppUserData()
    const userFeatures = appUserData.features?.[appUserData.uidSlave] || []

    useEffect(() => {
        setPortalTarget(document.querySelector('.sidenav') || document.body)
    }, [])

    const filteredOptions = listData.filter(item => {
        if (item.feature && item.admin) return appUserData.role === 'admin' && userFeatures.includes(item.feature)
        if (item.feature) return userFeatures.includes(item.feature)
        if (item.masterOnly) return appUserData.role === 'master' || appUserData.role === 'admin'
        return (appUserData.role === 'admin' && item.admin) || (appUserData.role !== 'admin' && !item.admin)
    })

    if (!portalTarget) return null

    return ReactDOM.createPortal(
        <div className="navigation">
            <div className={`submenu ${isOpen ? 'active' : ''}`}>
                <div className="submenu-title mt-10 mb-30">
                    <IconButtonSeeker
                        className="submenu-back mr-10 pull-right text-middle"
                        icon="arrow-left" iconType="fontAwesome" size="small"
                        onClick={onClose}
                    />
                    <IconSeekers className="submenu-icon pl-10 text-middle" icon="cog" iconType="fontAwesome" />
                    <span className="text-middle pl-10 item-text">Admin</span>
                </div>
                { filteredOptions.map((item, idx) =>
                    item.children ? <>
                        <a key={idx} className="nav-item" onClick={() => setExpanded(expanded === idx ? null : idx)}>
                            <ButtonBase className="w-100" style={{ justifyContent: 'flex-start' }}>
                                <IconSeekers className="item-icon text-middle" icon={item.icon || 'circle'} iconType="fontAwesome" style={ICON_STYLE} />
                                <span className="text-middle pl-10 item-text" style={{ marginRight: 'auto' }}>{item.label}</span>
                                <IconSeekers
                                    icon={expanded === idx ? 'chevron-down' : 'chevron-right'}
                                    iconType="fontAwesome"
                                    style={{ fontSize: 10, opacity: 0.7, marginRight: 4 }}
                                />
                            </ButtonBase>
                        </a>
                        { expanded === idx && item.children.map((child, cidx) =>
                            <NavLink key={`${idx}-${cidx}`} className="nav-item" to={child.route} onClick={onClose}>
                                <ButtonBase className="w-100" style={{ justifyContent: 'flex-start', paddingLeft: 20 }}>
                                    <span style={{ width: 20, textAlign: 'center', flexShrink: 0, fontSize: 14, opacity: 0.7 }}>●</span>
                                    <span className="text-middle pl-10 item-text" style={{ opacity: 0.8, fontSize: 13 }}>{child.label}</span>
                                </ButtonBase>
                            </NavLink>
                        )}
                    </> : (
                        <NavLink key={idx} className="nav-item" to={item.route} onClick={onClose}>
                            <ButtonBase className="w-100">
                                <IconSeekers className="item-icon text-middle" icon={item.icon || 'circle'} iconType="fontAwesome" style={ICON_STYLE} />
                                <span className="text-middle pl-10 item-text">{item.label}</span>
                            </ButtonBase>
                        </NavLink>
                    )
                )}
            </div>
        </div>,
        portalTarget
    )
}
